/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { Locale } from '@/types/i18n';
import { useAppState } from '@/stores/AppState';
import { countryCodes } from '@/constants/locale';
import { type Country } from '@/types';

export const useLocale = (): Locale => {
  const { locale } = useAppState().state;

  if (locale == null) {
    throw new Error('Locale is not set');
  }

  return locale;
};

export const useCountry = (): Country => {
  const locale = useLocale();

  switch (locale) {
    case countryCodes.us:
      return 'USA';
    case countryCodes.mx:
      return 'MEX';
    case countryCodes.ptBr:
      return 'BRA';
    default:
      throw new Error('Locale not supported');
  }
};
